import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AppBreadcrumbComponent } from './breadcrumb/app.breadcrumb.component';
import { BreadcrumbService } from './breadcrumb/breadcrumb.service';
import { AppConfigComponent } from './config/app.config.component';
import { AppFooterComponent } from './footer/app.footer.component';
import { AppMainComponent } from './main/app.main.component';
import { AppMenuComponent } from './menu/app.menu.component';
import { MenuService } from './menu/app.menu.service';
import { AppMenuitemComponent } from './menu/app.menuitem.component';
import { AppRightPanelComponent } from './rightpanel/app.rightpanel.component';
import { AppTopBarComponent } from './topbar/app.topbar.component';
import { TopBarService } from './topbar/app.topbar.service';
import { FormsModule } from '@angular/forms';
import { ProducerFinderComponent } from './producer-finder/producer-finder.component';
import { FertilizerFinderComponent } from './fertilizer-finder/fertilizer-finder.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        ButtonModule,
        ToolbarModule,
        CalendarModule,
        DropdownModule,
        CheckboxModule,
        RadioButtonModule,
        InputNumberModule,
        InputSwitchModule,
        AutoCompleteModule
    ],
    declarations: [
        AppBreadcrumbComponent,
        AppFooterComponent,
        AppMainComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppRightPanelComponent,
        AppConfigComponent,
        ProducerFinderComponent,
        FertilizerFinderComponent
    ],
    exports: [
        ProducerFinderComponent,
        FertilizerFinderComponent
    ],
    providers: [
        MenuService,
        BreadcrumbService,
        TopBarService
    ]
})
export class LayoutModule { }
